module.exports = __webpack_public_path__ + "img/express2016-min.26066a2d.jpg";